export default "__VITE_ASSET__pIcTVTu2__"